import React, { useState } from "react";
import { Col, Row, Table, Image, Modal, Button } from "react-bootstrap";
import Media from "react-media";
import BasicPagination from "../../Pagination/Pagination";
import LeftSideNavigation from "../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../navigationSection/RightSideNavigation";
import { TopNavigationBarMobile } from "../navigationSection/TopNavigationBarMobile";
import Accordion from "react-bootstrap/Accordion";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
import SlidingComponent from "../../reusableComponents/slidingToggleComponent/SlidingComponent";
import { NavLink } from "react-router-dom";
import SVG from "react-inlinesvg";
import MobileStaffManagement from './MobileStaffManagement';
import { Container } from "@material-ui/core";

const data = [
  {
    name: "Kelly McDonald",
    email: "sophiaj@email.com",
    profile_pic: "",
    mobile_number: "+91 1234523549",
    role: "Manager",
    active: false,
    accessbility: false,
  },
];




const StaffManagement = (props) => {
  const [staffs, setStaff] = useState(data);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);

  const renderRoleManagementAccordian = () => {
    return(
      staffs.slice(start, end).map((data, index) => (
        <MobileStaffManagement 
          indexKey={index}
          data={data}
        />
      )))
  }
  return (
    <React.Fragment>
      <div className="container-fluid superadmin-orderscomponent-main super-admin-vendor-private-orders">
        <Row>
          <div className="left-side-panel">
            <LeftSideNavigation />
          </div>
          <div className="top-panel">
            <TopNavigationBarMobile displayLeft="logo" />
          </div>
          <div className="right-side-panel">
            <RightSideNavigation
              displayButton="StaffManagement"
              StaffManagementButton={ <NavLink to="/addstaff" className="btn btn-danger btn2 btn-sm">
              + Add Staff
            </NavLink>}
              newButton={true}
            />
              <div className="d-flex justify-content-between align-items-center pt-4 pb-4 ">
                <div className="f24_700_HelveticaNeue"  style={{paddingLeft:'20px'}}>Staff Management</div>
                <Media query="(min-width: 991px)">
                  <NavLink to="/addstaff" className="btn btn-danger btn2 btn-lg">
                    + Add Staff
                  </NavLink>
                </Media>
              </div>
            <Container>
            <Row className="align-items-center">
              <Col className="col-auto seating-topbar-search">
                <div className="filter-button">
                  <Filter />
                </div>
              </Col>
              <Col xs={8} md={4}>
                <div className="filter-button-search">
                  <Paper component="form" className="enSearch2 d-flex">
                    <IconButton type="submit" aria-label="search">
                      <SearchIcon />
                    </IconButton>
                    <InputBase
                      placeholder="Search"
                      name="search"
                      inputProps={{
                        "aria-label": "Search by Name or Phone Number",
                      }}
                      //   onChange={onSearchChange}
                      //   value={state.search}
                    />
                  </Paper>
                </div>
              </Col>
            </Row>
            <Media query="(max-width: 991px)">
              <>
                <div className="row seating-dashboard-table">
                  <div className="col-3 mpr-1">
                    <p className="f12-700 pl-3">Name</p>
                  </div>
                  <div className="col-4 mpl-1 mpr-1">
                    <p className="f12-700">Email/<br /> Phone Number</p>
                  </div>
                  <div className="col-2 mpl-1">
                    <p className="f12-700">Roles</p>
                  </div>
                  <div className="col-3 mpl-1">
                    <p className="f12-700">Status</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 p-0">
                    <Accordion>{renderRoleManagementAccordian()}</Accordion>
                  </div>
                </div>
              </>
            </Media>
            <Media query="(min-width: 991px)">
              <div className="user-table-reusable-superadmin table-responsive">
                <Table>
                  <thead>
                    <tr className="super_admin_all_users_table_head">
                      <th style={{ width: "20%" }} className="f12-700">
                        Name
                      </th>
                      <th style={{ width: "15%" }} className="f12-700">
                        Email Address
                      </th>
                      <th style={{ width: "10%" }} className="f12-700">
                        Phone Number
                      </th>
                      <th style={{ width: "10%" }} className="f12-700">
                        Roles
                      </th>
                      <th style={{ width: "10%" }} className="f12-700">
                        Status
                      </th>
                      <th style={{ width: "10%" }} className="f12-700">
                        Availability
                      </th>
                      <th style={{ width: "25%" }} className="f12-700">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {staffs.map((data, index) => {
                      return (
                        <tr
                          key={index}
                          className="super_admin_all_users_table_body"
                          style={{ wordBreak: "break-word" }}
                        >
                          <td colSpan="7" className="p-0 w-100">
                            <table className="w-100 HideShowTable enMinWidth900">
                              <tbody>
                                <tr>
                                  <td style={{ width: "20%" }}>
                                    <div className="f14-500">{data.name}</div>
                                  </td>
                                  <td style={{ width: "15%" }}>
                                    <div className="f14-500">{data.email}</div>
                                  </td>
                                  <td style={{ width: "10%" }}>
                                    <div className="f12-400">
                                      {data.mobile_number}
                                    </div>
                                  </td>
                                  <td style={{ width: "10%" }}>
                                    <div className="f12-400">{data.role}</div>
                                  </td>
                                  <td style={{ width: "10%" }}>
                                    <div>
                                      <SlidingComponent
                                        name="status"
                                        checked={data.active}
                                        currentState={data.active}
                                        type={"checkbox"}
                                        toggleclass={
                                          "toggle vendor-super-admin-toggle d-flex align-items-center mb-2"
                                        }
                                        toggleinputclass={
                                          "toggle__switch vendor-super-admin-toggle"
                                        }
                                        onChange={() => {
                                          //   changeStatus(data._id, !data.active);
                                        }}
                                        // slidingonClick={this.onSelecttogglestatusChange(data)}
                                        // defaultChecked={true}
                                      />
                                      <div className="f10-500 mr-3">
                                        {data.active ? "Active" : "Inactive"}
                                      </div>
                                    </div>
                                  </td>
                                  <td style={{ width: "10%" }}>
                                    <div>
                                      <SlidingComponent
                                        name="status"
                                        checked={data.active}
                                        currentState={data.active}
                                        type={"checkbox"}
                                        toggleclass={
                                          "toggle vendor-super-admin-toggle d-flex align-items-center mb-2"
                                        }
                                        toggleinputclass={
                                          "toggle__switch vendor-super-admin-toggle"
                                        }
                                        onChange={() => {
                                          //   changeStatus(data._id, !data.active);
                                        }}
                                        // slidingonClick={this.onSelecttogglestatusChange(data)}
                                        // defaultChecked={true}
                                      />
                                      <div className="f10-500 mr-3">
                                        {data.active ? "Yes" : "No"}
                                      </div>
                                    </div>
                                  </td>
                                  <td style={{ width: "25%" }}>
                                    <div className="d-flex">
                                      <ViewModal data={data} />
                                      <NavLink to="/editstaff">
                                        <div className="enIconBtn mr-3">
                                          <Image
                                            src={require("../../../assets/images/UserManagement/pencil.svg")}
                                            alt="Edit"
                                            title="Edit"
                                            fluid
                                          />
                                        </div>
                                      </NavLink>
                                      <DeleteModal
                                        redButton={true}
                                        name="Role"
                                        // onClick={(handleCloseBlockUser) =>
                                        //   deleteRole(
                                        //     data._id,
                                        //     handleCloseBlockUser
                                        //   )
                                        // }
                                      />
                                      <FlagModal redButton={true} />
                                      <BlockModal redButton={true} />
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            </Media>
            </Container>
            <BasicPagination
              totalRecords={50}
              limit={5}
              //   batch={page}
              //   onBatchChange={(e) => handleBatchChange(e)}
            />
          </div>
          <div className="bottom-panel"></div>
        </Row>
      </div>
    </React.Fragment>
  );
};

export default StaffManagement;

const Filter = (props) => {
  const [open, setOpen] = useState(false);
  const [state, setState] = useState(0);
  const onOpenModal = () => setOpen(true);
  const onCloseModel = () => setOpen(false);
  return (
    <>
      <div
        onClick={onOpenModal}
        className="d-flex align-items-center justify-content-between cursor"
      >
        <Image
          alt="filter"
          title="filter"
          width="20px"
          src={require("../../../assets/images/ActionImages/image/filter.svg")}
        />
        <div className="f12-500 text-blue mx-2">Filter</div>
        <i className="fa fa-angle-down text-blue" aria-hidden="true"></i>
      </div>
      <Modal show={open} onHide={onCloseModel} centered>
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title>Filter</Modal.Title>
        </Modal.Header>
        <Modal.Body className="f16-500">
          Select one relevant option from below
          <Media query="(min-width: 991px)">
          <div className="row mt-4">
            <div className="col-6 col-md-4 mb-4">
              <div
                className={`status-selected-button-box f16-500 ${
                  state === 0 && `sts_sld_btn_box_a`
                }`}
                type="button"
                onClick={() => {
                  setState(0);
                }}
              >
                <div class="row justify-content-center">
                  <div class="">All</div>
                </div>
              </div>
            </div>
            <div class="col-6 col-md-4 mb-4">
              <div
                className={`status-selected-button-box f16-500 ${
                  state === 1 && `sts_sld_btn_box_a`
                }`}
                type="button"
                onClick={() => {
                  setState(1);
                }}
              >
                <div class="row justify-content-center">
                  <div class="">Active</div>
                </div>
              </div>
            </div>
            <div class="col-6 col-md-4 mb-4">
              <div
                className={`status-selected-button-box f16-500 ${
                  state === 2 && `sts_sld_btn_box_a`
                }`}
                type="button"
                onClick={() => {
                  setState(2);
                }}
              >
                <div class="row justify-content-center">
                  <div class="">Inactive</div>
                </div>
              </div>
            </div>
          </div>
          </Media>
          <Media query="(max-width: 991px)">
          <div className="row mt-4">
            <div className="col-6 col-md-6 mb-4">
              <div
                className={`status-selected-button-box f16-500 ${
                  state === 0 && `sts_sld_btn_box_a`
                }`}
                type="button"
                onClick={() => {
                  setState(0);
                }}
              >
                <div class="row justify-content-center">
                  <div class="">All</div>
                </div>
              </div>
            </div>
            <div class="col-6 col-md-6 mb-4">
              <div
                className={`status-selected-button-box f16-500 ${
                  state === 1 && `sts_sld_btn_box_a`
                }`}
                type="button"
                onClick={() => {
                  setState(1);
                }}
              >
                <div class="row justify-content-center">
                  <div class="">Active</div>
                </div>
              </div>
            </div>
            <div class="col-6 col-md-6 mb-4">
              <div
                className={`status-selected-button-box f16-500 ${
                  state === 2 && `sts_sld_btn_box_a`
                }`}
                type="button"
                onClick={() => {
                  setState(2);
                }}
              >
                <div class="row justify-content-center">
                  <div class="">Inactive</div>
                </div>
              </div>
            </div>
          </div>
          </Media>
        </Modal.Body>
        <Modal.Footer className="justify-content-start d-flex border-0">
          <Button
            variant="outline-secondary"
            className="btn-md "
            onClick={() => {
              setState(0);
              props.filterData(1, onCloseModel);
            }}
          >
            Reset Filter
          </Button>
          <Button
            variant="danger"
            className="btn-md "
            onClick={() => {
              props.filterData(state, onCloseModel);
            }}
          >
            Apply Filter
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

const BlockModal = (props) => {
  const [showBlockUser, seShowBlockUser] = useState(false);
  const handleCloseBlockUser = () => seShowBlockUser(false);
  const handleShowBlockUser = () => seShowBlockUser(true);
  return (
    <React.Fragment>
      {props.redButton ? (
        <div className="enIconBtn mr-3" onClick={handleShowBlockUser}>
          <Image
            src={require("../../../assets/images/iconButton/lock.png")}
            alt="Delete"
            title="Delete"
            fluid
          />
        </div>
      ) : (
        <button
          type="button"
          className="enBtnoutlineGrayIcon"
          onClick={handleShowBlockUser}
        >
          <SVG src={require("../../../assets/images/iconButton/lock.png")} />
        </button>
      )}
      <Modal show={showBlockUser} onHide={handleCloseBlockUser} centered>
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title>Block Staff</Modal.Title>
        </Modal.Header>
        <Modal.Body className="f16-500">
          Are you sure to Block the staff?
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          <Button
            variant="outline-secondary"
            className="btn-lg mr-4 px-5"
            onClick={handleCloseBlockUser}
          >
            No
          </Button>
          <Button
            variant="danger"
            className="btn-lg px-5"
            onClick={() => {
              handleCloseBlockUser();
              //   props.onClick(handleCloseBlockUser);
            }}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

const DeleteModal = (props) => {
  const [showBlockUser, seShowBlockUser] = useState(false);
  const handleCloseBlockUser = () => seShowBlockUser(false);
  const handleShowBlockUser = () => seShowBlockUser(true);
  return (
    <React.Fragment>
      {props.redButton ? (
        <div className="enIconBtn mr-3" onClick={handleShowBlockUser}>
          <Image
            src={require("../../../assets/images/UserManagement/Delete.svg")}
            alt="Delete"
            title="Delete"
            fluid
          />
        </div>
      ) : (
        <button
          type="button"
          className="enBtnoutlineGrayIcon"
          onClick={handleShowBlockUser}
        >
          <SVG
            src={require("../../../assets/images/UserManagement/Delete.svg")}
          />
        </button>
      )}
      <Modal show={showBlockUser} onHide={handleCloseBlockUser} centered>
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body className="f16-500">
          Are you sure to Delete the {props.name} ?
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          <Button
            variant="outline-secondary"
            className="btn-lg mr-4 px-5"
            onClick={handleCloseBlockUser}
          >
            No
          </Button>
          <Button
            variant="danger"
            className="btn-lg px-5"
            onClick={() => {
              handleCloseBlockUser();
              //   props.onClick(handleCloseBlockUser);
            }}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

const ViewModal = (props) => {
  const [ShowViewRole, setShowViewRole] = useState(false);
  const handleShowViewRole = () => setShowViewRole(!ShowViewRole);

  return (
    <>
      <div className="enIconBtn mr-3" onClick={handleShowViewRole}>
        <Image
          src={require("../../../assets/images/UserManagement/eye.svg")}
          alt="Edit"
          title="Edit"
          fluid
        />
      </div>
      <Modal show={ShowViewRole} onHide={handleShowViewRole} centered size="lg">
        <Modal.Header className="px-4 border-0" closeButton>
          <div>
            <Modal.Title className="f20-700 pb-2">
              View Staff Details
            </Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body className="px-4">
          <div className="row">
            <div className="col-4 f14-700 ">Status </div>
            <div className="col-4 f14-400 ">
              {data.active ? "Active" : "Inactive"}{" "}
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-4 f14-700 ">Availability </div>
            <div className="col-4 f14-400 ">{data.active ? "Yes" : "No"} </div>
          </div>
          <hr />
          <div className="row mt-2">
            <div className="col-4 f14-700 ">Role Name </div>
            <div className="col-4 f14-700 ">Select Role </div>
            <div className="col-4 f14-700 ">Location ID</div>
          </div>
          <div className="row mt-2">
            <div className="col-4 f14-400 ">Role Name </div>
            <div className="col-4 f14-400 ">Select Role </div>
            <div className="col-4 f14-400 ">
              Street Meat, Lane Number 6, Ganga Fortune Society, Meera Nagar, ….
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-6 f14-400 ">
              Drop a pin to your address Move the marker as required
            </div>
            <div className="col-6 f14-400 ">Auto Detect Location</div>
          </div>
          <div className="row mt-2">Location</div>
          <div className="row mt-2">
            <div className="col-3 f14-700 ">First Name</div>
            <div className="col-3 f14-700 ">Last Name</div>
            <div className="col-3 f14-700 ">Email Address</div>
            <div className="col-3 f14-700 ">Password</div>
          </div>
          <div className="row mt-2">
            <div className="col-3 f14-400 ">Alex</div>
            <div className="col-3 f14-400 ">Peter</div>
            <div className="col-3 f14-400 ">sophiaj@email.com</div>
            <div className="col-3 f14-400 ">***********</div>
          </div>
          <div className="row mt-2">
            <div className="col-3 f14-700 ">Phone Number</div>
            <div className="col-3 f14-700 ">Add Profile Photo</div>
          </div>
          <div className="row mt-2">
            <div className="col-3 f14-400 ">+91 9876543210</div>
            <div className="col-3 f14-400 ">Peter</div>
          </div>
          <hr />
          <div className="row mt-2">
            <div className="col-3 f14-700 ">Address Line 1</div>
            <div className="col-3 f14-700 ">Address Line 2</div>
            <div className="col-3 f14-700 ">State</div>
            <div className="col-3 f14-700 ">City</div>
          </div>
          <div className="row mt-2">
            <div className="col-3 f14-400 ">2887 Maple Street</div>
            <div className="col-3 f14-400 ">2887 Maple Street</div>
            <div className="col-3 f14-400 ">Maharashtra</div>
            <div className="col-3 f14-400 ">Pune</div>
          </div>
          <div className="row mt-2">
            <div className="col-3 f14-700 ">Country</div>
            <div className="col-3 f14-700 ">Zipcode</div>
            <div className="col-3 f14-700 ">Alternate Phone Number</div>
          </div>
          <div className="row mt-2">
            <div className="col-3 f14-400 ">India</div>
            <div className="col-3 f14-400 ">411002</div>
            <div className="col-3 f14-400 ">+91 9876543210</div>
          </div>
          <hr />
          <div className="row mt-2">
            <div className="col-3 f14-700 ">Select Status</div>
          </div>
          <div className="row mt-2">
            <div className="col-3 f14-400 ">Select Status</div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

const FlagModal = (props) => {
  const [showBlockUser, seShowBlockUser] = useState(false);
  const handleCloseBlockUser = () => seShowBlockUser(false);
  const handleShowBlockUser = () => seShowBlockUser(true);
  return (
    <React.Fragment>
      {props.redButton ? (
        <div className="enIconBtn mr-3" onClick={handleShowBlockUser}>
          <Image
            src={require("../../../assets/images/UserManagement/flag.svg")}
            alt="Delete"
            title="Delete"
            fluid
          />
        </div>
      ) : (
        <button
          type="button"
          className="enBtnoutlineGrayIcon"
          onClick={handleShowBlockUser}
        >
          <SVG
            src={require("../../../assets/images/UserManagement/flag.svg")}
          />
        </button>
      )}
      <Modal show={showBlockUser} onHide={handleCloseBlockUser} centered>
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title>Flag Staff</Modal.Title>
        </Modal.Header>
        <Modal.Body className="f16-500">
          Are you sure to Flag the staff?
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          <Button
            variant="outline-secondary"
            className="btn-lg mr-4 px-5"
            onClick={handleCloseBlockUser}
          >
            No
          </Button>
          <Button
            variant="danger"
            className="btn-lg px-5"
            onClick={() => {
              handleCloseBlockUser();
              props.onClick(handleCloseBlockUser);
            }}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};
